import type { SVGProps } from "react";
// generated from Logout.svg — do not edit manually
// prettier-ignore
export default function Logout(props: SVGProps<SVGSVGElement>) {
  return (<svg viewBox="0 0 24 24" fill="none"
    xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2M17 7L22 12M22 12L17 17M22 12H8" stroke="currentColor" strokeWidth="1.5"/>
</svg>);
}
